import type { ProductCatalogCollection } from './ProductCatalogCollection';
import bestsellersCollection from './bestsellers';
import newProductsCollection from './newProducts';
import onSaleCollection from './onSale';

export const productCatalogCollections: ProductCatalogCollection[] = [
  onSaleCollection,
  newProductsCollection,
  bestsellersCollection,
];

export const productCatalogCollectionsBySlug = new Map(
  productCatalogCollections.map(collection => [collection.slug, collection])
);

export type { ProductCatalogCollection } from './ProductCatalogCollection';
